import { useMemo } from 'react'

import {
  getOrderedPremises,
  getPremisesWithoutGuestParking,
  getPremisesWithoutParkingPlaces
} from '../lib/main.utils'
import { useSelectedProject } from './useSelectedProject'

export const useSelectedProjectPremises = () => {
  const { selectedProject } = useSelectedProject()

  const premises = useMemo(
    () => selectedProject?.premises || [],
    [selectedProject?.premises]
  )

  const withoutGuestParking = useMemo(
    () => getPremisesWithoutGuestParking(premises),
    [premises]
  )

  const rooms = useMemo(
    () => getOrderedPremises(getPremisesWithoutParkingPlaces(premises)),
    [premises]
  )

  const getPremiseNameById = (premiseId: string) => {
    return rooms.find(premise => premiseId === premise.id)?.name
  }

  return {
    premises,
    rooms,
    withoutGuestParking,
    getPremiseNameById
  }
}
